// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2026 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import * as React from "react";

const GraphicPodcast: React.FC = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="38" height="38" viewBox="0 0 38 38" fill="currentColor">
            <g fill="currentColor" fillRule="evenodd" transform="translate(1 1)">
                <path
                    fill="currentColor"
                    d="M22.1110162 16.9748802C22.4138057 17.1612653 22.5980223 17.4894844 22.5980223 17.8431331 22.5980223 18.1966832 22.4138057 18.5250008 22.1110162 18.6922644L16.0130406 22.4191774C15.6991133 22.6288237 15.3063346 22.6373002 14.985705 22.4573218 14.6650753 22.2773434 14.4664683 21.9384794 14.4664683 21.570046L14.4664683 14.1161215C14.4664683 13.7485753 14.6650753 13.4095141 14.985705 13.2295357 15.3063346 13.0497545 15.6991133 13.0571468 16.0130406 13.2487558L22.1110162 16.9748802ZM18.1215378 25.9772596 21.0780722 36.6704996C21.1239046 36.8361861 20.9992208 37 20.8273247 37L14.9142557 37C14.7423596 37 14.6176758 36.8361861 14.6635082 36.6704996L17.6200426 25.9772596C17.6904176 25.7227666 18.0511629 25.7227666 18.1215378 25.9772596"
                />
                <path
                    stroke="#666"
                    strokeLinecap="round"
                    d="M9.9500652,33.8469776 C4.05493494,30.9363741 0,24.8628425 0,17.842108 C0,7.9886358 7.98765016,0 17.842108,0 C27.6955802,0 35.6832304,7.9886358 35.6832304,17.842108 C35.6832304,24.8628425 31.6292811,30.9363741 25.7341508,33.8469776"
                />
                <path
                    stroke="#666"
                    strokeLinecap="round"
                    d="M11.1683198,30.011841 C6.87485931,27.6531975 3.96524144,23.0876996 3.96524144,17.842108 C3.96524144,10.1777487 10.1777487,3.96524144 17.842108,3.96524144 C25.5054816,3.96524144 31.7189746,10.1777487 31.7189746,17.842108 C31.7189746,23.0867139 28.8093567,27.6522119 24.5158962,30.011841"
                />
                <path
                    stroke="#666"
                    strokeLinecap="round"
                    d="M12.4023448,26.1303792 C9.70759704,24.3581933 7.92949723,21.3076285 7.92949723,17.842108 C7.92949723,12.3678473 12.3678473,7.93048287 17.842108,7.93048287 C23.3163687,7.93048287 27.7537331,12.3678473 27.7537331,17.842108 C27.7537331,21.3076285 25.9756333,24.3581933 23.2818712,26.1303792"
                />
            </g>
        </svg>
    );
};

export default React.memo(GraphicPodcast);
